const SUPPORTED_REGIONS = new Set(['uk', 'us'])

export function normalizeRegion(region) {
  return SUPPORTED_REGIONS.has(region) ? region : 'uk'
}

export function getRegionFromPathname(pathname = '/') {
  if (pathname.startsWith('/us/') || pathname === '/us') return 'us'
  if (pathname.startsWith('/uk/') || pathname === '/uk') return 'uk'
  return 'uk'
}

export function getWebsiteFromRegion(region) {
  return normalizeRegion(region)
}
